import { render, staticRenderFns } from "./d-book-review-actions.vue?vue&type=template&id=546db20d&"
import script from "./d-book-review-actions.vue?vue&type=script&lang=js&"
export * from "./d-book-review-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports